import React, { useState, useMemo, useContext } from "react";
import { Tooltip, Tabs, Button } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";
import { useParams } from "react-router-dom";

import TrialModal from "../../common/TrialModal";
import popupImg from "../../assets/images/free-user-login-prompt.jpg.jpeg";
import KeyExecutives from "./KeyExecutives";
import {
  getEmployeeList,
  getExecutiveTag,
  resetExecutiveTag,
  emptyErrorObj,
  downloadExecutiveExl,
} from "../../actionCreator/executiveDetailsActionCreator";
import { getUserInfo } from "../../utils/utils";
import { saveExcel, savePDF } from "../../utils";
import { useExport } from "../executive-search/hooks/useExport";
import { errEnum } from "../../config";
import TagExecutive from "../executive-search/TagExecutive";
import { useAlert } from "../../context/AlertProvider";
import { AuthContext } from "../../context/AuthContext";
import FeatureComingSoon from "../../common/FeatureComingSoon";
import pdf from "../../assets/svg/pdf.svg";
import tag from "../../assets/svg/tag.svg";

const SummaryContent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { isAuthenticated: isLoggedIn } = useContext(AuthContext);
  const { getSchema, columns } = useExport();
  const { id } = useParams();
  const [tabActiveKey, setTabActiveKey] = useState("1");
  const [openTagModal, setOpenTagModal] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const executiveCompanyDetails = useSelector(
    (state) => state.executiveDetailsReducer.executiveCompanyDetails,
  );

  const userAccountInfo = useSelector(
    (state) => state.CommonReducer.accountInfo,
  );

  const selectedEmployeeList = useSelector(
    (state) => state.executiveDetailsReducer.selectedColleague,
  );

  const executiveDetails = useSelector(
    (state) => state.executiveDetailsReducer.executiveDetails,
  );
  const employeeList = useSelector(
    (state) => state.executiveDetailsReducer.employeeList,
  );

  const errObj = useSelector((state) => state.executiveDetailsReducer.errObj);

  useMemo(() => {
    if (Object.keys(getUserInfo()).length && executiveCompanyDetails.length) {
      const { id } = getUserInfo();
      dispatch(resetExecutiveTag());
      const [executiveCompanyDetails1] = executiveCompanyDetails;
      dispatch(getExecutiveTag(executiveCompanyDetails1?.id, id));
    }
  }, [executiveCompanyDetails, userAccountInfo]);

  const items = [
    {
      key: "1",
      label: "Colleagues",
      children: <KeyExecutives />,
    },
  ];

  const onChange = (key) => {
    setTabActiveKey(key);
    if (key !== "2") {
      dispatch(getEmployeeList(id));
    }
  };

  const tagExecutive = () => {
    checkLoginStatus();
    if (isLoggedIn) {
      if (selectedEmployeeList?.length) {
        setOpenTagModal(true);
      } else {
        showAlert("warning", "please select record.");
      }
    }
  };

  const closeTagModal = () => {
    setOpenTagModal(false);
  };

  const checkLoginStatus = () => {
    if (isLoggedIn) {
      setShowModal(false);
    } else {
      setShowModal(true);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    dispatch(emptyErrorObj());
  };

  const redirectToSignup = () => {
    setShowModal(false);
    navigate("/signup");
  };

  const onExport = async (type) => {
    checkLoginStatus();
    if (isLoggedIn) {
      let selectedEmpIds = "";
      selectedEmployeeList?.forEach((exe) => {
        selectedEmpIds += `${exe?.id},`;
      });
      selectedEmpIds = selectedEmpIds.substring(
        selectedEmpIds.lastIndexOf(","),
        0,
      );
      const [executiveCompanyDetails1] = executiveCompanyDetails;
      const payload = {
        empIds: selectedEmpIds,
        companyId: executiveCompanyDetails1?.id,
        id: executiveDetails?.id,
      };
      const res = await dispatch(downloadExecutiveExl(payload, type));
      if (res?.length) {
        const downloadedUpdatedData = getSchema(res);
        const fileName = executiveCompanyDetails1.name + "-executive-data";
        if (type === "exl") {
          saveExcel(downloadedUpdatedData, columns, fileName);
        } else {
          savePDF(downloadedUpdatedData, columns, fileName);
        }
        showAlert(
          "success",
          "Download Complete",
          <div>
            The colleague data for {executiveDetails.fullname} has been
            successfully downloaded to{" "}
            {type === "exl" ? (
              <FileExcelOutlined style={{ color: "#4CAF50" }} />
            ) : (
              <FilePdfOutlined style={{ color: "#f44336" }} />
            )}
            .
          </div>,
        );
      }
    }
  };

  return (
    <>
      <div className="row">
        <div id="executive" className="col-md-12">
          <div className="mt-4 mb-4">
            <div className="buttons-c mr-3">
              <div className="d-flex justify-content-end flex-wrap align-items-center gap-20 m-mt">
                {!!employeeList?.length && (
                  <div className="d-flex align-items-center gap-10">
                    <Tooltip title="Tag Executive">
                      <img
                        src={tag}
                        alt=""
                        className="w-20 h-20 cursor-pointer"
                        onClick={tagExecutive}
                      />
                    </Tooltip>
                    <Tooltip title="Download Excel">
                      <i
                        className="right-icons la la-file-excel"
                        aria-hidden="true"
                        onClick={() => onExport("exl")}
                      ></i>
                    </Tooltip>
                    <Tooltip title="Download PDF">
                      <img
                        src={pdf}
                        alt=""
                        className="w-20 h-20 cursor-pointer"
                        onClick={() => onExport("pdf")}
                      />
                    </Tooltip>
                  </div>
                )}
                <div className="d-flex justify-content-end align-items-center gap-20">
                  <FeatureComingSoon>
                    <Button className="secondary-btn">
                      <i className="fa fa-plus" aria-hidden="true"></i> Create
                      List
                    </Button>
                  </FeatureComingSoon>

                  <FeatureComingSoon>
                    <Button className="secondary-btn">
                      <i className="fs-14 mr-1 fas fa-paper-plane"></i>Send
                      Campaign
                    </Button>
                  </FeatureComingSoon>
                </div>
              </div>
            </div>

            <Tabs activeKey={tabActiveKey} items={items} onChange={onChange} />
          </div>
        </div>
      </div>
      {errObj[errEnum.DOWNLOAD_ERROR] && (
        <TrialModal
          openModal={!!errObj[errEnum.DOWNLOAD_ERROR]}
          closeModal={() => dispatch(emptyErrorObj())}
          buttonText="OK"
          modalBody={
            <div id="small-dialog2">
              {errObj[errEnum.DOWNLOAD_ERROR]
                ? errObj[errEnum.DOWNLOAD_ERROR].message
                : "Unable to complete the action. Please try again later."}
            </div>
          }
          modalWidth="400px"
        />
      )}

      {showModal ? (
        <TrialModal
          openModal={showModal}
          closeModal={closeModal}
          redirectToSignup={redirectToSignup}
          redirect={true}
          buttonText="Start Free Trial"
          modalBody={
            <div id="small-dialog2">
              <div align="center">
                <img src={popupImg} alt="" />
              </div>
              <p style={{ color: "#0000FF" }}>
                Get 10 free verified contacts with a BeyondLeadz Pro trial
              </p>
              <p>
                BeyondLeadz Pro customers close deals faster thanks to relevant
              </p>
            </div>
          }
          modalWidth="400px"
        />
      ) : (
        ""
      )}

      <TagExecutive
        title="Tag Colleague"
        selectedRecords={selectedEmployeeList?.map((d) => d?.id)}
        showTagModal={openTagModal && !!selectedEmployeeList?.length}
        closeTagModal={closeTagModal}
      />
    </>
  );
};

export default SummaryContent;
